import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const Label = ({ children, ...props }) => {
    return _jsx("label", { ...props, children: children });
};
